import { FC } from 'react';

import { Input, type InputProps } from 'components/ui/input';
import { Label } from 'components/ui/label';

export type FileInputProps = Omit<InputProps, 'type' | 'onChange'> & {
  isHidden?: boolean;
  onUpload: (file: File) => void;
};

export const FileInput: FC<FileInputProps> = ({
  onUpload,
  isHidden = false,
  ...props
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      onUpload(files[0]);
    }
  };

  if (isHidden) {
    return (
      <Input
        data-testid="hidden-file-input"
        id="dropzone-file"
        className="hidden"
        aria-describedby="file_upload_help"
        {...props}
        onChange={handleChange}
        type="file"
      />
    );
  }

  return (
    <>
      <Label
        className="block mb-2 text-md font-semibold text-gray-900"
        htmlFor="file_upload"
      >
        Upload a file
      </Label>
      <Input
        className="!p-0 block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
        aria-describedby="file_upload_help"
        {...props}
        onChange={handleChange}
        type="file"
      />
      <div className="mt-1 text-sm text-gray-500" id="user_avatar_help">
        Localisez et sélectionnez le fichier que vous souhaitez télécharger.
      </div>
    </>
  );
};
